import { fileRefSchema, toFileRef, type FileRef } from "./files";

// Le node `file` : un fichier par node, dans `values.file`, sous la forme
// d'une `FileRef` — celle du champ `file` des custom nodes (cf. `lib/files`).
//
// Il a remplacé le node `pdf`, qui portait une liste `values.files` dont
// l'interface ne montrait que la première entrée.

/**
 * Le fichier d'un node `file`, lu défensivement : une référence qui ne passe
 * plus la validation (nom devenu trop long…) se lit quand même.
 */
export function readNodeFile(values: Record<string, unknown> | null | undefined): FileRef | null {
  if (!values) return null;
  const stored = fileRefSchema.safeParse(values.file);
  return stored.success ? stored.data : toFileRef(values.file);
}

/**
 * Ce qu'une écriture met dans `values.file` : une `FileRef` complète, ou
 * `null` pour vider le node. Le reste est refusé — une URL seule n'est pas
 * un fichier (l'agent passe par `agentNodeFileInput`, qui la résout).
 */
export function parseNodeFileValue(
  raw: unknown,
): { ok: true; value: FileRef | null } | { ok: false; error: string } {
  if (raw === null) return { ok: true, value: null };
  const parsed = fileRefSchema.safeParse(raw);
  if (parsed.success) return { ok: true, value: parsed.data };
  return {
    ok: false,
    error: "`file` must be an uploaded file reference ({ key, url, name, mime, size }) or null.",
  };
}
